class CollapsibleContent extends HTMLElement {
  constructor() {
    super();

    this.triggers = this.querySelectorAll(".trigger");

    this.triggers.forEach((trigger) => {
      const drawer = trigger.nextElementSibling;

      trigger.addEventListener("click", this.handleTriggerClick.bind(this));
    });
  }

  handleTriggerClick({ currentTarget }) {
    const activeAccordion = document.querySelector(".active.accordion-group");

    if (activeAccordion && activeAccordion != currentTarget.parentElement) {
      activeAccordion.classList.remove("active");
      activeAccordion
        .querySelector(".accordion-drawer")
        ?.removeAttribute("style");
    }

    const drawerEl = currentTarget.nextElementSibling;

    drawerEl?.getAttribute("style")
      ? drawerEl.removeAttribute("style")
      : drawerEl.setAttribute("style", `height: ${drawerEl.scrollHeight}px`);
    currentTarget.parentElement.classList.toggle("active");
  }
}

customElements.define("collapsible-content", CollapsibleContent);
